<style>
    :host ::ng-deep p-toast div.ui-toast {
        z-index: 1200 !important;
    }
</style>

<p-toast></p-toast>